import { useEffect, useState } from 'react';

const HEADER_HEIGHT_PX = 66;

function useFullHeight() {
    const [height, setHeight] = useState<number>(0);
    useEffect(() => {
        const onResize = () => {
            setHeight(window.innerHeight - HEADER_HEIGHT_PX);
        };
        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return height;
}

export default useFullHeight;
